/* Endurrad — «AVVISAMI QUANDO DISPONIBILE» fuori dalla scheda prodotto (20/10/2026). File aggiunto: sopravvive agli aggiornamenti del tema.
   Caricato da snippets/endurrad-app-stile.liquid. Stile: assets/endurrad-confronta.css (classi .erd-avv).
   - Schede nelle griglie (snippets/erd-card.liquid): campanella [data-erd-avv-card] sui prodotti esauriti.
     Prodotto con una sola variante → apre la finestra qui; con più varianti → va alla scheda prodotto con #avvisami,
     dove si sceglie la variante e la finestra della scheda si apre da sola.
   - Confronto (assets/endurrad-confronta.js): chiama window.erdAvvisami.apri({...}).
   - Scheda prodotto in pre-ordine: link «Preferisci non pagare ora? Avvisami…» sotto il riquadro del pre-ordine.
   Invio: stesso App Proxy della scheda prodotto e dell'app, /apps/endurrad/stock-request
   (email a support@endurrad.com, metaoggetto letto da Riordino Endurrad, email al cliente al ritorno). */
(function () {
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var CAMPANA = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10.3 21a1.9 1.9 0 0 0 3.4 0"/></svg>';
  var dlg = null, corrente = null, origine = null;

  function crea() {
    var c = window.erdCliente || {};
    var privacy = (window.erdPrivacyUrl || '/policies/privacy-policy');
    dlg = document.createElement('dialog');
    dlg.className = 'erd-avv';
    dlg.setAttribute('aria-labelledby', 'ErdAvvGlobT');
    dlg.innerHTML =
      '<div class="erd-avv__in">' +
        '<button type="button" class="erd-avv__x" data-x aria-label="Chiudi">×</button>' +
        '<form data-form novalidate>' +
          '<div class="erd-avv__ico">' + CAMPANA + '</div>' +
          '<h2 id="ErdAvvGlobT">Avvisami quando disponibile</h2>' +
          '<p>Ti scriviamo appena <b data-nome></b> torna disponibile.</p>' +
          '<div class="erd-avv__g">' +
            '<label><span>Nome</span><input type="text" name="firstName" autocomplete="given-name" maxlength="80" required value="' + esc(c.nome) + '"></label>' +
            '<label><span>Cognome</span><input type="text" name="lastName" autocomplete="family-name" maxlength="80" required value="' + esc(c.cognome) + '"></label>' +
          '</div>' +
          '<label><span>Email</span><input type="email" name="email" autocomplete="email" inputmode="email" maxlength="254" required value="' + esc(c.email) + '"></label>' +
          '<label><span>Telefono <small>(facoltativo)</small></span><input type="tel" name="phone" autocomplete="tel" inputmode="tel" maxlength="30" value="' + esc(c.tel) + '"></label>' +
          '<label class="erd-avv__hp" aria-hidden="true">Sito web<input type="text" name="website" tabindex="-1" autocomplete="off"></label>' +
          '<label class="erd-avv__ok"><input type="checkbox" name="consent" required><span>Accetto che Endurrad usi questi dati per avvisarmi della disponibilità di questo prodotto. <a href="' + esc(privacy) + '" target="_blank">Informativa sulla privacy</a></span></label>' +
          '<p class="erd-avv__err" data-err role="alert" hidden></p>' +
          '<button type="submit" class="erd-avv__go" data-go>' + CAMPANA + 'Avvisami</button>' +
        '</form>' +
        '<div data-fatto hidden style="display:flex;flex-direction:column;gap:12px">' +
          '<div class="erd-avv__ico is-ok">✓</div>' +
          '<h2>Fatto, ti avviseremo</h2>' +
          '<p>Ti scriviamo a <b data-mail></b> appena il prodotto torna disponibile.</p>' +
          '<div class="erd-avv__app"><p><b>Vuoi l’avviso anche sul telefono?</b> Con l’app Endurrad ricevi la notifica appena torna disponibile.</p>' +
            '<div class="erd-avv__store"><a href="https://apps.apple.com/it/app/id6477457847" target="_blank" rel="nofollow noopener" data-store="ios">App Store</a>' +
            '<a href="https://play.google.com/store/apps/details?id=com.endurrad" target="_blank" rel="nofollow noopener" data-store="android">Google Play</a></div></div>' +
          '<button type="button" class="erd-avv__go" data-x>Chiudi</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(dlg);
    var ua = navigator.userAgent || '';
    if (/iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) $('[data-store="android"]', dlg).hidden = true;
    if (/Android/i.test(ua)) $('[data-store="ios"]', dlg).hidden = true;
    $$('[data-x]', dlg).forEach(function (b) { b.addEventListener('click', chiudi); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) chiudi(); });
    dlg.addEventListener('close', function () { if (origine && origine.focus) origine.focus(); });
    $('[data-form]', dlg).addEventListener('submit', invia);
  }

  function chiudi() { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }

  function apri(dati, da) {
    if (!dati || !dati.productId || !dati.variantId) return;
    if (!dlg) crea();
    corrente = dati; origine = da || null;
    var f = $('[data-form]', dlg);
    f.hidden = false; $('[data-fatto]', dlg).hidden = true; $('[data-err]', dlg).hidden = true;
    $('[data-nome]', dlg).textContent = dati.titolo || 'il prodotto';
    if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', '');
    var primo = $$('input', f).filter(function (i) { return !i.value && i.name !== 'website' && i.type !== 'checkbox'; })[0];
    if (primo && !window.matchMedia('(pointer: coarse)').matches) primo.focus();
  }

  function mailOk(m) { var a = m.split('@'); return a.length === 2 && a[0].length > 0 && a[1].indexOf('.') > 0 && a[1].slice(-1) !== '.' && m.indexOf(' ') < 0; }

  function invia(e) {
    e.preventDefault();
    var f = e.target, el = f.elements, err = $('[data-err]', dlg), go = $('[data-go]', dlg), msg = '';
    err.hidden = true;
    ['firstName', 'lastName', 'email', 'phone'].forEach(function (k) { el[k].classList.remove('is-err'); });
    var val = function (k) { return (el[k].value || '').trim(); };
    if (!val('firstName')) { el.firstName.classList.add('is-err'); msg = msg || 'Scrivi il tuo nome.'; }
    if (!val('lastName')) { el.lastName.classList.add('is-err'); msg = msg || 'Scrivi il tuo cognome.'; }
    if (!mailOk(val('email'))) { el.email.classList.add('is-err'); msg = msg || "Inserisci un'email valida."; }
    if (val('phone') && (!/^[+]?[0-9 ]+$/.test(val('phone')) || val('phone').replace(/[^0-9]/g, '').length < 6)) { el.phone.classList.add('is-err'); msg = msg || 'Telefono: usa solo cifre, spazi e il segno +.'; }
    if (!msg && !el.consent.checked) msg = "Per continuare accetta l'uso dei dati.";
    if (msg) { err.textContent = msg; err.hidden = false; return; }
    go.disabled = true;
    fetch('/apps/endurrad/stock-request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        productId: +corrente.productId, variantId: +corrente.variantId,
        firstName: val('firstName'), lastName: val('lastName'), email: val('email'), phone: val('phone'),
        consent: true, website: el.website.value || '',
        lang: ((window.Shopify && Shopify.locale) || document.documentElement.lang || 'it').slice(0, 2)
      })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || !j.ok) throw new Error(j.error || ('Invio non riuscito (codice ' + r.status + '). Riprova tra poco.'));
      });
    }).then(function () {
      $('[data-mail]', dlg).textContent = val('email');
      f.hidden = true; $('[data-fatto]', dlg).hidden = false;
    }).catch(function (x) {
      err.textContent = x && x.message && !/fetch|network|load failed/i.test(x.message) ? x.message : 'Connessione non riuscita. Controlla la rete e riprova.';
      err.hidden = false;
    }).then(function () { go.disabled = false; });
  }

  /* Campanella sulle schede (anche caricate dopo: filtri, «Mostra altri», raccomandati) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-erd-avv-card], .erd-card__ship.is-avv');
    if (!b) return;
    if (!b.hasAttribute('data-erd-avv-card')) {
      var card = b.closest('.erd-card');
      b = card && $('[data-erd-avv-card]', card);
      if (!b) return;
    }
    e.preventDefault();
    if (b.getAttribute('data-multi') === '1') { window.location.href = b.getAttribute('data-url') + '#avvisami'; return; }
    apri({ productId: b.getAttribute('data-pid'), variantId: b.getAttribute('data-vid'), titolo: b.getAttribute('data-titolo') }, b);
  });

  /* Scheda prodotto aperta con #avvisami: apre la finestra della scheda (sections/erd-prodotto.liquid) */
  function daHash() {
    if (location.hash !== '#avvisami') return;
    var b = $('.erd-pp__cta [data-erd-avv]') || $('[data-erd-avv]');
    if (b) setTimeout(function () { b.click(); }, 300);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', daHash); else daHash();

  /* Scheda prodotto in PRE-ORDINE: chi non vuole pagare subito può chiedere l'avviso.
     Il link sta sotto il riquadro «Prodotto in pre-ordine» e apre la finestra Avvisami della scheda, con la variante scelta. */
  function preordine() {
    var box = $('.erd-pp__cta [data-erd-pre]'), btn = $('.erd-pp__cta [data-erd-avv]');
    if (!box || !btn || $('[data-erd-avv-pre]')) return;
    var l = document.createElement('button');
    l.type = 'button';
    l.className = 'erd-avv-pre';
    l.setAttribute('data-erd-avv-pre', '');
    if (!$('#erd-avv-pre-css')) { var st = document.createElement('style'); st.id = 'erd-avv-pre-css'; st.textContent = '.erd-avv-pre{display:flex;align-items:center;gap:10px;width:100%;margin-top:10px;padding:11px 14px;border:1.5px dashed #BCD6F8;border-radius:12px;background:#fff;color:#111418;font:inherit;font-size:13px;line-height:1.35;text-align:left;cursor:pointer}.erd-avv-pre:hover{border:1.5px solid #086CE5}.erd-avv-pre svg{width:20px;height:20px;flex:0 0 20px;color:#086CE5}.erd-avv-pre b{color:#086CE5}.erd-avv-pre[hidden]{display:none}'; document.head.appendChild(st); }
    l.innerHTML = CAMPANA + '<span><b>Preferisci non pagare ora?</b> Avvisami quando arriva in magazzino</span>';
    box.parentNode.insertBefore(l, box.nextSibling);
    l.addEventListener('click', function () { btn.click(); });
    function sync() { l.hidden = box.hidden; }
    sync();
    if ('MutationObserver' in window) new MutationObserver(sync).observe(box, { attributes: true, attributeFilter: ['hidden'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preordine); else preordine();

  window.erdAvvisami = { apri: apri };
})();